import { z } from 'zod';
import type { LoginInput } from '@eombor/contracts';

/**
 * Forma sxemasi. `@eombor/contracts` dagi `loginSchema` bilan **bir xil
 * qoidalar**, lekin xabarlar maydon yonida turishga moslangan: shartnomadagi
 * matn API iste'molchisi uchun, bu yerdagisi esa maydonni to'ldirayotgan
 * odam uchun yozilgan.
 */
export const loginFormSchema = z.object({
  username: z
    .string()
    .trim()
    .min(3, 'Loginni kiriting')
    .max(60)
    .regex(/^[A-Za-z][A-Za-z0-9]*$/, "Login lotin harfi bilan boshlanadi (masalan: AnvarAliyev)"),
  password: z.string().min(1, 'Parolni kiriting').max(200),
});

export type LoginFormValues = z.infer<typeof loginFormSchema>;

/**
 * Forma qiymatlari backend kutgan `LoginInput` ga mosligi tur darajasida
 * qulflanadi.
 *
 * CAPTCHA CHIPTASI solishtiruvdan CHIQARILADI va bu ataylab: uni odam
 * yozmaydi — kod alohida tekshirilib, chipta serverdan keladi va so'rovga
 * `LoginRoute` qo'shadi. Formaga qo'shilsa, `LoginPage` ni sinash uchun ham
 * tarmoq kerak bo'lardi.
 */
type Assert<T extends true> = T;
type Credentials = Omit<LoginInput, 'captchaToken'>;
export type LoginFormMatchesContract = Assert<LoginFormValues extends Credentials ? true : false>;
